import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { waLink } from "../data/content";

const LINKS = [
  { id: "manifesto", label: "Manifesto", testId: "nav-manifesto" },
  { id: "layanan", label: "Layanan", testId: "nav-services" },
  { id: "portofolio", label: "Portofolio", testId: "nav-portfolio" },
  { id: "kontak", label: "Kontak", testId: "nav-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#0D0E11]/85 backdrop-blur-md border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-home"
          onClick={() => window.__lenis?.scrollTo(0) ?? window.scrollTo({ top: 0 })}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif-lux text-2xl tracking-tight text-bone group-hover:text-gold transition-colors duration-300">
            Raditya
          </span>
          <span className="font-mono-arch text-[10px] tracking-[0.3em] text-brass uppercase">
            Konstruksi
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="font-mono-arch text-[11px] tracking-[0.22em] uppercase text-ash hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-whatsapp-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono-arch text-[11px] tracking-[0.22em] uppercase text-obsidian bg-brass hover:bg-gold px-5 py-2.5 transition-colors duration-300"
          >
            Konsultasi WA
          </a>
        </nav>

        <a
          data-testid="nav-whatsapp-mobile"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="md:hidden font-mono-arch text-[10px] tracking-[0.2em] uppercase text-obsidian bg-brass px-4 py-2"
        >
          WA
        </a>
      </div>
    </motion.header>
  );
};
